var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{attrs:{"width":206,"height":60,"speed":2,"viewBox":"0 0 60 206","primaryColor":_vm.primaryColor,"secondaryColor":"#D1D1D1"}},[_c('rect',{attrs:{"x":"10","y":"0","rx":"5","ry":"5","width":"206","height":"60"}})])}
var staticRenderFns = []

export { render, staticRenderFns }